import { render, staticRenderFns } from "./ListItemMenu.vue?vue&type=template&id=635ad73c"
import script from "./ListItemMenu.vue?vue&type=script&lang=js"
export * from "./ListItemMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports